import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
@Input() loaderClass: string;
@Input() svgCircleClass: string;
@Input() svgCirclePathClass: string;
@Input() cx = 50;
@Input() cy = 50;
@Input() r = 20;
@Input() strokeWidth = 2;
@Input() strokeMiterlimit = 10;
@Input() isEnable = false;

  constructor() { }

  ngOnInit() {  }

}
